import React from "react";

import {SponsoredOfferBox} from "../components/SponsoredOfferBox";
import {ICreation} from "../types/ICreation";

interface IProps {
    creation: ICreation;
    url: string;
}

export const NativeCreation = (props: IProps) => {
    const {creation, url} = props;

    return <SponsoredOfferBox creation={creation} url={url} />;
};
import React from "react";

import {SponsoredOfferBox} from "../components/SponsoredOfferBox";
import {ICreation} from "../types/ICreation";

interface IProps {
    creation: ICreation;
    url: string;
}

export const NativeCreation = (props: IProps) => {
    const {creation, url} = props;

    return <SponsoredOfferBox creation={creation} url={url} />;
};
